import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { HelpSiteReview } from "@shared/models/analytics/help-site"
import type { KbEntry } from "@shared/models/kb-entry"
import type { PreparedAction } from "../../action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "../create-narrative"
import createNarrative from "../create-narrative"

interface Payload {
  article: KbEntry
}

export default function prepareKbSadFaceClicked(payload: Payload): PreparedAction {
  return {
    name: "KB_SAD_FACE_CLICKED",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: HelpSiteReview = {
    ...createBlankEvent(),
    root_id: "help_site",
    root_type: "app",

    primary_verb: "use",

    primary_object_type: "app",
    primary_object_id: "help_site",
    primary_object_id_and_ancestor_ids: ["help_site", payload.article.id],

    adverbial_verb: "clicking",

    adverbial_object_type: "reaction",
    adverbial_object_id: "sad_face",
    adverbial_object_id_and_ancestor_ids: ["help_site", payload.article.id, "sad_face"],
  }
  return createNarrative({
    title: "Sad Face Selected",
    description: "User indicated that the article did not answer their question",
    titleForAnalytics: "KB Article - Sad Face Clicked",
    context: {
      articleId: payload.article.id,
      articleTitle: payload.article.attributes.title,
    },
    newAnalyticsEvents: [newEvent],
  })
}
